import type { TimelineData } from './milestone.types';
import { MilestoneWithScroll } from './ui';

interface MilestoneRendererProps {
  block: TimelineData;
}
export function MilestoneRenderer({ block }: MilestoneRendererProps) {
  const { heading, timelineItems, backgroundColor } = block;

  return <MilestoneWithScroll heading={heading} timelineItems={timelineItems} backgroundColor={backgroundColor} />;
}
